<template>
  <el-table :data="tableData" style="width: 100%" v-loading="isLoading" stripe class="office-summary-table">
    <el-table-column prop="storeNum" label="Store No." width="110" sortable />
    <el-table-column prop="efin" label="EFIN" width="100" sortable />
    <el-table-column prop="address" label="Address" sortable />
    <el-table-column prop="new" label="New" width="110" sortable />
    <el-table-column prop="returning" label="Returning" width="125" sortable />
    <el-table-column prop="total" label="Total" width="110" sortable />
  </el-table>
</template>

<script>
import api from '@/api';
import ReportData from '@/mixin/ReportData';

export default {
  name: 'OfficeNvRTable',
  mixins: [ReportData],
  props: {
    priorYear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      tableData: [],
    };
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      api.report.getOfficeNvRReport(this.dateRange, this.forOffice, this.priorYear).then((response) => {
        this.tableData = response.data;
      }).finally(() => {
        this.isLoading = false;
      });
    },
  },
  mounted() {
    this.fetchData();
  },
};

</script>

<style lang="scss">
.office-summary-table .el-table__body-wrapper {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
